import { useState } from 'react';
import Modal from '@mui/material/Modal';
import ErrorHandler from '@Root/ErrorHandler';
import { IoClose as Close } from 'react-icons/io5';
import { ReactComponent as DeleteIcon } from '@Assets/delete.svg';
import { ReactComponent as FormIcon } from '@Assets/form.svg';
import BorderRedButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderRedButtonV2';
import BorderWhiteButtonV2 from '@CommonRepresentationalDisplay/Buttons/BorderWhiteButtonV2';
import KaiziqResolveConnectionService from '@Helpers/URLHelpers/KaiziqResolveConnectionService';
import './DeleteKaiziqResolveConnectionForm.scss';

export default function DeleteKaiziqResolveConnectionForm(props) {

    const [cursor, setCursor] = useState('auto');
    const kaiziqResolveConnectionService = new KaiziqResolveConnectionService();
    const errorHandler = new ErrorHandler();
    const className = 'deleteKaiziqResolveConnectionForm';

    const timeout = (delay: number) => {
        return new Promise(res => setTimeout(res, delay));
    }

    const handleDelete = async (e) => {
        e?.preventDefault();
        setCursor('wait');
        try {
            await kaiziqResolveConnectionService.deleteKaiziqResolveConnection(props.kaiziqResolveConnection.id);
            await timeout(500);
            window.location.reload();
        } catch (err) {
            errorHandler.handleError(err);
        }
        setCursor('auto');
        props.closePopup();
    };

    return (
        <Modal
            open={props.open}
            onClose={props.closePopup}
            style={{ cursor: cursor }}
            className={className}>
                <div className={className + '__inner flex-column-flex-start'}>
                    <div className={className + '__inner__titleBar width-wfa'}>
                        <div className={className + '__inner__titleBar__title flex-row-center-0p5rem-gap'}>
                            <div className={className + '__inner__titleBar__title__tag'}>
                                <FormIcon className={className + '__inner__titleBar__title__tag__icon grey-text'} />
                            </div>
                            <div className={className + '__inner__titleBar__title__t1 flex-row-flex-end standard-text-semi-large red-text semi-bold-text'}>
                                <DeleteIcon className={className + '__inner__titleBar__title__t1__icon'} />
                                Delete Form
                            </div>
                        </div>
                        <Close className={className + '__inner__titleBar__close close-button'} onClick={props.closePopup} />
                    </div>
                    <div className={className + '__inner__name flex-column-flex-start'}>
                        <div className={className + '__inner__name__tag large-text'}>
                            {props.kaiziqResolveConnection.title}
                        </div>
                    </div>
                    <form className={className + '__inner__form flex-column-flex-start width-wfa'} onSubmit={handleDelete}>
                        <div className={className + '__inner__form__info flex-column-flex-start'}>
                            <div className={className + '__inner__form__info__t1'}>Are you sure you want to delete this form?</div>
                            <div className={className + '__inner__form__info__t2 grey-text small-text'}>All the data and content in this form will be permanently deleted and cannot be recovered.</div>
                        </div>
                        <div className={className + '__inner__form__buttonFlex flex-row-center-1rem-gap width-wfa'}>
                            <div className={className + '__inner__form__buttonFlex__delete width-wfa'}>
                                <BorderRedButtonV2
                                    text='Delete'
                                    onClick={handleDelete}
                                    disabled={cursor === 'wait'}/>
                            </div>
                            <div className={className + '__inner__form__buttonFlex__cancel width-wfa'}>
                                <BorderWhiteButtonV2
                                    text='Cancel'
                                    onClick={props.closePopup}
                                    disabled={cursor === 'wait'}/>
                            </div>
                        </div>
                    </form>
                </div>
        </Modal>
    );
}
